export default __webpack_public_path__ + "static/media/position_finder_icon.6e870fbe.svg";